import React from "react";
import { RouteObject } from "react-router-dom";
import withSuspense from "../../components/wrappers/WithSuspense";

import LoginPage from "./pages/Login.page";
import SignupPage from "./pages/Signup.page";
const ForgotPage = React.lazy(() => import("./pages/Forgot.page"));

// todo: add custom loader
export const authRoutes: RouteObject[] = [
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "signup",
    element: <SignupPage />,
  },
  {
    path: "forgot-password",
    element: withSuspense(ForgotPage),
  },
];
